import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { EventType, AuthenticationResult } from "@azure/msal-browser";
import { GetUserInfo, GetUserRoles } from "@/services/api/user-endpoints";
import { equipOptionsInstance } from "@/models/EquipOptions";

export default function AccountInterceptor() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (!instance.getActiveAccount() && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }

    const cbId = instance.addEventCallback(async (event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ) {
        const result = event.payload as AuthenticationResult;
        if (result?.account) {
          instance.setActiveAccount(result.account);
        }
      }
    });

    return () => {
      if (cbId) instance.removeEventCallback(cbId);
    };
  }, [instance, accounts]);

  return null;
}
